// MIRRORS: panel/hooks/useDebouncedValue.ts — identical copy; edit both, or delete this line on both to declare a deliberate split.
import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed until it has stopped changing for `delayMs`, so an
 * input can stay instant while whatever it triggers fires once at the end.
 *
 * The cancellation is React's own: the cleanup runs before the effect re-runs,
 * so a new keystroke clears the pending timer and starts a fresh one. Only a
 * timer nobody interrupted ever reaches `setSettled`.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
